import { render } from "./Header.vue?vue&type=template&id=24e4c272&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=24e4c272&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24e4c272"

export default script